// styled-components
import styled from 'styled-components';

/********************************* styled *********************************/

export const Header = styled.div`
    z-index: 999;
    display: flex;
    justify-content: space-between;

    background-color: rgb(66, 139, 247);

    border-top-left-radius: 9px;
    border-top-right-radius: 9px;

    height: 5vh;

    align-items: center;

    @media (max-width: 1120px) {
        width: 100%;
    }
`;

export const Text = styled.div`
    padding: 0 15px;

    color: #fff;
    font-size: 16px;
    font-weight: 600;

    line-height: 45px;
`;

export const SchedulePayUserDetailModalWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100%;

    background-color: #000000b0;
`;

export const SchedulePayUserDetailModalBox = styled.div`
    position: relative;

    display: flex;
    flex-direction: column;
    justify-content: start;

    width: 120vh;
    max-width: 98%;
    height: 78vh;

    border-radius: 10px;
    background-color: #fff;

    @media (max-width: 912px) {
        width: 98%;
        height: 95%;

        overflow: auto;
    }

    .close-window {
        padding: 5px 25px;
        text-align: start;
        font-size: 20px;
        color: #428bf7;
    }

    .close-icon {
        position: absolute;
        top: 0;
        right: 0;

        padding: 15px;
        color: gray;
    }
`;

export const UserName = styled.span`
    cursor: pointer;
    user-select: none;

    width: 200px;
    border: 1px solid rgba(66, 139, 247, 0.2);

    text-align: start;
    font-size: 15px;
    font-weight: 600;

    margin: 20px 30px;
    padding: 3px 50px 3px 7px;

    @media (max-width: 912px) {
        margin-top: 15%;
    }
`;

export const ModalBoxBody = styled.div`
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    padding: 0px 30px;

    #label {
        display: none;
    }

    @media (max-width: 912px) {
        flex-direction: column;

        .refund-info {
            margin-top: 7%;
        }
    }
`;

export const InfoBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;

    width: 100%;
    height: 59vh;

    border-left: ${(props) => (props.leftLine ? '1px solid gray' : '')};
    padding-left: ${(props) => (props.leftLine ? '2%' : '')};

    @media (max-width: 912px) {
        border-left: none;
        height: auto;
    }
`;

export const InfoTitle = styled.h2`
    margin: 0 0 15px 0;

    font-size: 17px;
    font-weight: 600;
`;

export const ColWrapper = styled.div`
    display: flex;
    align-items: start;

    margin-bottom: 3%;
`;

export const Subtitle = styled.div`
    font-size: 13px;
    color: gray;

    width: 90px;
`;

export const SubInfo = styled.div`
    font-size: 13.5px;
    font-weight: 500;
`;

export const Footer = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 5px;

    width: 98.5%;

    @media (max-width: 912px) {
        justify-content: center;

        margin: 5% 0;
    }
`;

export const CancelButton = styled.button`
    cursor: pointer;

    width: 100px;
    height: 33px;

    margin: 1.5% 0;

    border: 1px solid rgb(229, 229, 229);
    border-radius: 3px;

    background-color: #fff;
    color: #000;

    :hover {
        background-color: #f6f6f6;
    }

    :active {
        background-color: #fff;
    }
`;

export const RefundButton = styled.button`
    cursor: pointer;

    width: 100px;
    height: 33px;

    margin: 1.5% 0;

    border: 0;
    border-radius: 3px;

    background-color: rgb(255, 16, 125);
    color: #fff;

    :hover {
        background-color: rgb(233 4 108);
    }

    :active {
        background-color: rgb(255, 16, 125);
    }
`;

const Select = styled.select`
    cursor: pointer;
    width: 120px;
    height: 23px;

    outline: none;
    border: 1px solid rgb(202 202 202);

    font-size: 13.5px;
`;

const Input = styled.input`
    outline: none;
    border: 1px solid #cccccc;

    padding: 1px 5px;
    height: 21px;

    ::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
`;

const Button = styled.button`
    cursor: pointer;
    border: 0;
    border-radius: 3px;
    background-color: #fff;
    color: #fff;

    border: ${(props) => (props.token ? '#cccccc' : '1px solid rgb(255, 16, 125)')};
    background-color: ${(props) => (props.token ? '#cccccc' : 'rgb(255, 16, 125)')};

    width: 100px;
    height: 25px;

    :hover {
        background-color: ${(props) => (props.token ? '#cccccc' : 'rgb(255, 16, 125)')};
    }
`;
